import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ShipmentsData } from 'models/Shipments';

const initialState: ShipmentLabelDetailsState = {
    open: false,
    dialogContent: null,
};

export const shipmentLabelDetailsDialogSlice = createSlice({
    name: 'shipmentLabelDetailsDialog',
    initialState,
    reducers: {
        setOpen: (state, action: PayloadAction<boolean>) => {
            state.open = action.payload;
        },
        setShipmentLabelDetailsDialog: (
            state,
            action: PayloadAction<ShipmentsData>
        ) => {
            state.dialogContent = action.payload;
        },
    },
});

export interface ShipmentLabelDetailsState {
    open: boolean;
    dialogContent: ShipmentsData | null | undefined;
}

export const shipmentLabelDetailsDialogAction =
    shipmentLabelDetailsDialogSlice.actions;

export default shipmentLabelDetailsDialogSlice.reducer;
